import { z } from 'zod';

import { IdentitySignalSchema } from '../identity-signal/identity-signal';

/**
 * Every signal captured for one member — types and dates, never a value
 * (`03-trust-ban-evasion.md` §admin Trust module).
 *
 * An envelope rather than a bare array, on the convention the settings details
 * response set: a top-level array is the one response shape that cannot grow a
 * `meta` later without breaking every consumer at once. It is **not** paginated,
 * and that is a bounded decision rather than an omission — a member has at most
 * one signal per registered type per capture point, which is single digits.
 *
 * Staff-only, on `trust.review`. There is no member-facing twin: a member who
 * could enumerate their own captured signals could work out which of them the
 * platform matches on, which is the same oracle the deliberately neutral
 * blocked-registration error exists to avoid.
 */
export const MemberSignalsResponseSchema = z
  .object({
    items: z.array(IdentitySignalSchema),
  })
  .strict();

export type MemberSignalsResponse = z.infer<typeof MemberSignalsResponseSchema>;
